import AdvancedFilterCheckbox from './advanced_filter_checkbox';
import AdvancedFilterSubcategoryView from './advanced_filter_subcategory_view';

export default Backbone.View.extend({
  initialize(options) {
    const self = this;
    this.childViews = [];

    // Create views for each of the checkboxes
    _.each(this.$('.js-search-advanced-filter-checkbox'), el => {
      const view = new AdvancedFilterCheckbox({
        el: $(el),
        model: self.model,
        fieldName: $(el).attr('data-field-name'),
      });
      self.childViews.push(view);
    });

    // Create views for each of the subcategories
    _.each(this.$('.js-filter-subcategory'), el => {
      const view = new AdvancedFilterSubcategoryView({
        el: $(el),
        model: self.model,
      });
      self.childViews.push(view);
    });
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/search/advanced_filters_view.js